
export class Theme {

    public static Colours = {
        background: '#f9faf7',
        workArea: '#ffffff',
        border: '1.5px solid #e0e0e0',
        text: '#000000',
        buttonBackground: '#817ee4',
        buttonText: '#ffffff',
        tableHeader: '#f7f7f7',
        // Light yellowish tint marking Development feature areas.
        superHighlight: '#fef9c3',
        // Deeper yellow for a selected Development menu item.
        superHighlightSelected: '#f5d547',
    }

    public static Dimensions = {
        borderRadius: '4px',
        padding: '10px',
        margin: '10px',
    }

    public static Fonts = {
        h1: {
            fontSize: '30px',
            fontWeight: '600',
        },
        h2: {
            fontSize: '20px',
            fontWeight: 'bold',
        },
        body: {
            fontSize: '14px',
            fontWeight: 'normal',
        },
        title1: {
            fontSize: '20px',
        },
        title2: {
            fontSize: '16px',
        },
    }
}
